import { useColorMode } from '@chakra-ui/react';

export const useIsLightMode = () => useColorMode().colorMode === 'light';
